import FileInputV3 from '@efex-components/EfexDS/FileInput/FileInput';
import { OnboardingDocumentTypeIds } from '@efex-services/documents/types';
import {
  Alert,
  AlertTitle,
  Typography,
  FormControl,
  FormControlLabel,
  Checkbox,
  Box,
  Grid,
  Link,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PUBLIC_URLS } from '@utils/urls';
import { LANGUAGES_LOWERCASE } from '@constants/leng';
import { useFormContext } from 'react-hook-form';
import { UseFileServiceReturn } from '@efex-components/EfexDS/FileInput/types/useFileService.type';
import useFileService from '@efex-components/EfexDS/FileInput/useFileService';
import BussinesNature from '../BussinesNature/BussinesNature';

const CompanyOperation = ({
  useExistingFileService,
}: {
  useExistingFileService?: UseFileServiceReturn;
}) => {
  const { watch, setValue } = useFormContext();

  const isCompanyOperating = watch('isCompanyOperating');

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const defaultFileService = useFileService();

  const fileServiceToUse = useExistingFileService || defaultFileService;

  const {
    onboardingDocuments,
    errorUploadDocuments: error,
    handleChangeFile,
    handleDeleteFile,
    handleDropChangeFile,
  } = fileServiceToUse;

  const handleCheckboxChange = (value: boolean) => {
    setValue('isCompanyOperating', value);
  };

  return (
    <Grid container flexDirection={{ xs: 'column' }}>
      <FormControl component="fieldset" className="mb-4">
        <Typography variant="h6">{t('doYouHaveCompanyOperation')}</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', mt: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isCompanyOperating === true}
                onChange={() => {
                  handleCheckboxChange(true);
                }}
                sx={{ '& .MuiSvgIcon-root': { borderRadius: 0 } }}
              />
            }
            label={t('doYouHaveCompanyOperationYesOption')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={!isCompanyOperating}
                onChange={() => {
                  handleCheckboxChange(false);
                }}
                sx={{ '& .MuiSvgIcon-root': { borderRadius: 0 } }}
              />
            }
            label={t('doYouHaveCompanyOperationNoOption')}
          />
        </Box>
      </FormControl>
      {isCompanyOperating ? (
        <Grid item xs={12} md={6}>
          <Alert severity="info" variant="outlined">
            <AlertTitle>{t('operationRequirements')}</AlertTitle>
            <Typography variant="body2" className="!mb-2">
              {t('operationRequirementsMessage')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('operationRequirementsOption1')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('operationRequirementsOption2')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('operationRequirementsOption3')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('operationRequirementsOption4')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('operationRequirementsOption5')}
            </Typography>
            <Typography component="p" variant="caption">
              {t('operationRequirementsOption6')}
            </Typography>
          </Alert>
          <FileInputV3
            isSingleFile
            inputName="companyOperation"
            onChange={handleChangeFile}
            onDropChange={handleDropChangeFile}
            onDelete={handleDeleteFile}
            error={error}
            documents={onboardingDocuments?.filter(
              (element) =>
                element.document.type.id ===
                OnboardingDocumentTypeIds.companyOperation
            )}
          />
          <BussinesNature useExistingFileService={fileServiceToUse} />
        </Grid>
      ) : (
        <Grid item xs={12} md={6}>
          <Box display="flex">
            <Typography sx={{ mb: 2 }}>
              {t('doYouHaveCompanyOperationDesc')}
            </Typography>

            <Typography sx={{ mb: 2, ml: 1 }}>
              <Link
                href={
                  language === LANGUAGES_LOWERCASE.en
                    ? PUBLIC_URLS.S3.ONBOARDING.BUSSINES_MODEL_EN
                    : PUBLIC_URLS.S3.ONBOARDING.BUSSINES_MODEL_ES
                }
                target="_blank"
              >
                {t('doYouHaveCompanyOperationDownloadTemplate')}
              </Link>
            </Typography>
          </Box>

          <FileInputV3
            isSingleFile
            inputName="companyOperation"
            onChange={handleChangeFile}
            onDropChange={handleDropChangeFile}
            onDelete={handleDeleteFile}
            error={error}
            documents={onboardingDocuments?.filter(
              (element) =>
                element.document.type.id ===
                OnboardingDocumentTypeIds.companyOperation
            )}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default CompanyOperation;
